import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BenutzerverwaltungComponent } from './components/benutzerverwaltung/benutzerverwaltung.component';
import { RouterModule, Routes } from '@angular/router';
import { RouteNames } from '../../route.name';
import { InsightSharedModule } from '../insight-shared/insight-shared.module';

const routes: Routes = [
    {path: RouteNames.BASE, component: BenutzerverwaltungComponent}
];


@NgModule({
    declarations: [
        BenutzerverwaltungComponent
    ],
    imports: [
        CommonModule,
        InsightSharedModule,
        RouterModule.forChild(routes)
    ],
    exports: [
        BenutzerverwaltungComponent
    ]
})
export class BenutzerverwaltungModule {
}
